import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {StoreModule} from '@ngrx/store';
import * as fromUsage from './+state/usage.reducer';
import {EffectsModule} from '@ngrx/effects';
import {UsageEffects} from './+state/usage.effects';
import {NGXLogger} from 'ngx-logger';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature(
      fromUsage.USAGE_FEATURE_KEY,
      fromUsage.reducer
    ),
    EffectsModule.forFeature([UsageEffects]),
  ]
})
export class UsageStoreModule {

  constructor(private logger: NGXLogger) {
    logger.trace('*---------------------------------------------------------------------*');
    logger.trace('*', this.constructor.name, 'Loaded');
    logger.trace('*---------------------------------------------------------------------*');
  }

}
